// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Loading_Wrapper__3Ps8o"};